import { DateTime } from 'luxon'

import { PlatformDevice } from '@/client/services/platform/constants'
import composeRichText from '@/client/services/richText/composeRichText'
import { getVolunteerOpenRolesPageUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import { DEADLINE } from '@/components/Volunteer/constants'

import { makeBannerDataLoader } from './helpers'

const BANNER_SLUG = 'volunteer-hub-may-2024'

export default makeBannerDataLoader({
  name: 'volunteer-hub',
  load(context) {
    const shouldRender =
      DateTime.fromISO(context.requestTimestamp, { zone: 'utc' }) < DEADLINE &&
      hasUserRole(context.user, 'user:tutor')

    if (!shouldRender) {
      return null
    }

    if (context.user.platformDevice === PlatformDevice.DESKTOP) {
      return {
        slug: BANNER_SLUG,
        content: composeRichText(ctx => [
          ctx.paragraph(
            'Schoolhouse volunteer applications are now open! Visit the ',
            ctx.linkInternal(getVolunteerOpenRolesPageUrl(), 'Volunteer Hub'),
            ' to apply.'
          ),
        ]),
      }
    }

    return {
      slug: BANNER_SLUG,
      content: composeRichText(ctx => [
        ctx.paragraph(
          'Volunteer applications are open! Apply now at the ',
          ctx.linkInternal(getVolunteerOpenRolesPageUrl(), 'Volunteer Hub')
        ),
      ]),
    }
  },
})
